export function getResultByResponse(response) {
  return {
    body: response === null || response === void 0 ? void 0 : response.data,
    headers: response === null || response === void 0 ? void 0 : response.headers,
    status: response === null || response === void 0 ? void 0 : response.status,
    statusText: response === null || response === void 0 ? void 0 : response.statusText
  };
}
//# sourceMappingURL=getResultByResponse.js.map
